module.exports = __webpack_public_path__ + "img/mir.ad47425d.png";